// extracted by mini-css-extract-plugin
module.exports = {"btn_linkedin":"style_btn_linkedin__LRrMR","disabled":"style_disabled__jfUDz","no-touch":"style_no-touch__KTByM"};